var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.119873,
    width: 36,
    height: 36,
    rx: 12,
    fill: "#1877F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5219 27.8052V20.9953H21.7924L22.2246 18.178H19.5219V16.3495C19.5219 15.5785 19.9 14.8287 21.1098 14.8287H22.3392V12.4321C22.3392 12.4321 21.2244 12.2406 20.1587 12.2406C17.9308 12.2406 16.4771 13.5895 16.4771 16.0319V18.178H14.002V20.9953H16.4771V27.8052C11.8199 27.0735 8.25781 23.0416 8.25781 18.1781C8.25771 12.7956 12.6171 8.43457 17.9995 8.43457C23.3819 8.43457 27.7429 12.7955 27.7429 18.178C27.7429 23.0415 24.1808 27.0735 19.5219 27.8052Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbb);
export default __webpack_public_path__ + "static/media/fbb.0ab91a209266bf69629454fb922ed804.svg";
export { ForwardRef as ReactComponent };